/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class OrganisationDto {
    id: string;
    chamberOfCommerce: string;
    name: string;
    address: string;
    countryCode: string;
    postalCode: string;
    city: string;
    contactPhoneNumber: string;
    contactEmailAddress: string;
    contactEmailAddressBilling: string;
    supportEmailAddress: string;
    supportPhoneNumber: string;
    apiUrl: string;
    colorAmountToShowByDefault: number;
}
